import styled from "styled-components";
import CustomLabel from "../../../customUiForCs/CustomLabel";
import CustomCheckbox from "../../../helperComponents/CustomCheckbox";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const List = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  flex-wrap: wrap;
`;
export default function RolePermissionEditor({
  label,
  onChange,
  value,
  hideCreate,
  hideDelete,
  hideUpdate,
}) {
  if (!value) value = [];

  return (
    <Container>
      <CustomLabel>{label}</CustomLabel>
      <List>
        {hideUpdate ? null : (
          <CustomCheckbox
            label="Modifier"
            value={value.includes("UPDATE")}
            onChange={updatePermission("UPDATE")}
          />
        )}

        {hideCreate ? null : (
          <CustomCheckbox
            label="Créer"
            value={value.includes("CREATE")}
            onChange={updatePermission("CREATE")}
          />
        )}

        <CustomCheckbox
          label="Voir"
          value={value.includes("VIEW")}
          onChange={updatePermission("VIEW")}
        />

        {hideDelete ? null : (
          <CustomCheckbox
            label="Supprimer"
            value={value.includes("DELETE")}
            onChange={updatePermission("DELETE")}
          />
        )}
      </List>
    </Container>
  );

  function updatePermission(permissionName) {
    return (receivedBoolean) => {
      if (receivedBoolean) {
        if (!value.includes(permissionName)) {
          let newValue = [...value];
          newValue.push(permissionName);
          onChange(newValue);
        }
      } else {
        console.log(value);
        if (value.includes(permissionName)) {
          let newValue = [...value];
          let theIndex = newValue.indexOf(permissionName);
          newValue.splice(theIndex, 1);
          onChange(newValue);
          console.log(newValue);
        }
      }
    };
  }
}
